var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusSuccessRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#6BC7A1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 12l4 4 8-8.666",
    stroke: "#2DBA6E",
    strokeWidth: 1.5
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxMiIgY3k9IjEyIiByPSIxMiIgZmlsbD0iIzZCQzdBMSIvPgo8cGF0aCBkPSJNNi42NjYwMiAxMi4wMDAyTDEwLjY2NiAxNi4wMDAyTDE4LjY2NiA3LjMzMzUiIHN0cm9rZT0iIzJEQkE2RSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPC9zdmc+Cg==";
export { SvgStatusSuccessRound as ReactComponent };